module.exports = __webpack_public_path__ + "img/greater_wind_elemental_small.338640f6.png";